export enum DepositStepEnum {
  INPUT_AMOUNT = 1,
  SEND_USDT = 2,
}
